<template>
    <user-team-card-legacy
        :user="order?.referral.referredBy as LegacyUser"
        :team="order?.referral.referredByBranch"
        :assignable-users="legacyAssignableCreatorUsers"
        :editable="false && isUserOfAssignedCompany && canChangeReferrer"
        @user-change="changeReferrer($event)"
    >
        <template #title>
            <text-decorator :size="FontSize.sm">
                Aanmaker
            </text-decorator>
        </template>
    </user-team-card-legacy>
</template>

<script setup lang="ts">
    import { Order, OrderAPI, User as LegacyUser } from '@keyvue/one-api-client-legacy';
    import { FontSize, TextDecorator } from '@keyvue/one-ui';
    import UserTeamCardLegacy from '@components/Cards/UserTeamCardLegacy.vue';
    import { Lead, User } from '@keyvue/one-api-client';
    import useClient from '@composables/useClient';
    import useNotify from '@composables/useNotify';
    import useLeadSecurity from '@composables/security/useLeadSecurity';
    import { computed } from 'vue';
    import useEventBus from '@composables/useEventBus';

    export interface Props {
        order: Order
        lead: Lead
    }

    const props = defineProps<Props>();
    const { client } = useClient();
    const { notifySaving, notifySaved } = useNotify();
    const { canChangeReferrer, isUserOfAssignedCompany } = await useLeadSecurity(props.lead);
    const eventBus = useEventBus();

    const [
        assignableCreatorUserCollection,
    ] = await Promise.all([
        await client.getSubResources(props.lead.referrer.team, User, 'available-users'),
    ]);

    const assignableCreatorUsers = computed(() => assignableCreatorUserCollection.data);

    const legacyAssignableCreatorUsers = computed(() => assignableCreatorUsers.value.map((user: User) => LegacyUser.fromData({
        id: user.id.toString(),
        firstname: user.name?.firstName,
        middlename: user.name?.middleName,
        lastname: user.name?.lastName,
    })));

    const changeOrderField = async (callback: (o: Order) => Order) => {
        const closeNotification = notifySaving(undefined, 0);
        const legacyOrder = await OrderAPI.get(props.order.id);
        await OrderAPI.update(props.order.id, callback(legacyOrder));
        notifySaved();
        if (closeNotification) {
            closeNotification();
        }
    };

    const changeReferrer = async (user: LegacyUser) => {
        const legacyUser = LegacyUser.fromOne(user);
        await changeOrderField((o: Order) => {
            const changedOrder = o;
            changedOrder.referral.referredBy = legacyUser;
            return changedOrder;
        });

        eventBus.dispatch('resource-manipulated', 'Order');
    };
</script>
